// Dynamic field configuration for different games
export interface GameFieldConfig {
  name: string;
  type: 'string' | 'number' | 'boolean' | 'select';
  label: string;
  description?: string;
  required?: boolean;
  defaultValue?: any;
  options?: string[]; // For select type
  min?: number; // For number type
  max?: number; // For number type
  minLength?: number; // For string type
  maxLength?: number; // For string type
  sensitive?: boolean;
  hasDefault?: boolean;
}

export interface ServerPackage {
  _id?: string;
  name: string;
  displayName: string;
  description: string;
  game: string; // minecraft, valheim, etc.
  price: number; // in RON
  ram: number; // in GB
  cpu: number; // vCPU count
  storage: number; // in GB
  maxPlayers: number;
  isFree: boolean;
  isActive: boolean;
  
  // Dynamic game-specific settings with their configurations
  gameSettings: {
    [key: string]: any;
  };
  
  autoShutdown?: {
    enabled: boolean;
    idleMinutes: number; // Minutes without players before shutdown
  };
  createdAt?: Date;
  updatedAt?: Date;
}

export interface CreatePackageRequest {
  name: string;
  displayName: string;
  description: string;
  game: string;
  price: number;
  ram: number;
  cpu: number;
  storage: number;
  maxPlayers: number;
  isFree: boolean;
  gameSettings: { [key: string]: any };
  autoShutdown?: {
    enabled: boolean;
    idleMinutes: number;
  };
}

export interface UpdatePackageRequest extends Partial<CreatePackageRequest> {
  isActive?: boolean;
}

export const SUPPORTED_GAMES = [
  'minecraft',
  'valheim',
] as const;

export type SupportedGame = typeof SUPPORTED_GAMES[number];
